import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {ServiceNotesPage} from "./-page/service-notes.page";
import {ServiceNotesPending} from "./-page/service-notes.pending";
import {serviceNotesSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/engineering/services/$serviceId/notes/")({
  component: RouteComponent,
  pendingComponent: ServiceNotesPending,
  staticData: {meta: {labelDescriptor: routeMessages.notes}},
  validateSearch: (search) => serviceNotesSearchSchema.parse(search),
});

function RouteComponent() {
  const {serviceId} = useParams({strict: false}) as {serviceId: string};
  const {includeDeleted} = Route.useSearch();

  return <ServiceNotesPage serviceId={serviceId} includeDeleted={includeDeleted} />;
}
